
import { showAlert } from "../redux/alert/alertActions";
import { apiResponseFailure } from "../redux/api/apiActions";
import messages from "./messages";
import descriptions from "./descriptions";

// List of specific errors to handle with a different response
const refreshTokenErrors = [
  "Invalid refresh token.",
  "Invalid or blacklisted refresh token.",
  "Invalid user for the refresh token.",
  "Access token expired, please use refresh token to get a new one.",
  "The refresh token has expired. Please request a new one.",
  "Refresh token has expired.",
  "Refresh token expired"
];

const ERROR_TYPES = [
  "invalidToken",
  "expiredAccessToken",
  "invalidAccessToken",
  "invalidRefreshToken",
  "expiredRefreshToken",
  "invalidAccessOrRefresh",
  "sessionInactive",
  "noToken",
  "invalidAppKey",
  "missingAppKey",
  "dangerousManipulation",
  "missingSessionToken",
  "invalidSession",
  "missingAllTokens",
];

const GEO_ERROR_TYPES = [
  "geoLocationError",
  "geoLocationTimeout",
  "geoLocationPermissionDenied",
  "geoLocationPositionUnavailable",
  "unknownLocation"
];

const errorChecker = (errorMessage,type, dispatch, errorTitle) => {
  const defaultLanguage = localStorage.getItem('language') || "en";
  

  if (refreshTokenErrors.includes(errorMessage) || (ERROR_TYPES.includes(type)) || (GEO_ERROR_TYPES.includes(type))) {
    
  } else {
    const title=defaultLanguage === "en" ? errorTitle : (messages[errorTitle] || errorTitle)

    const fallbackMessage = descriptions[errorMessage]?.[defaultLanguage] || errorMessage;
    dispatch(
      apiResponseFailure({
        operation: "default",
        key: "default",
        error: errorMessage,
      })
    )
    dispatch(
      showAlert({
        type: "error",
        title: title,
        message: fallbackMessage,
      })
    );
  }
};

export default errorChecker;
